module.exports = __webpack_public_path__ + "img/icon_4.38b3d4fb.png";